class NumbersCard
    constructor: (el) ->
        @.$el = el
        @.$itemsNumbers = @.$el.querySelectorAll '.numbers-card__item__number'

        @.thousandsSeparator = @.$el.dataset?.tSep ? '.'

        @.FormatNumbers()
        @.$el.classList.add 'numbers-card--bound'
        return

    FormatNumbers: ->
        self = @
        @.$itemsNumbers.forEach (numberEl) ->
            numberEl.innerHTML = numberEl.innerHTML.toString().replace(/\B(?=(\d{3})+(?!\d))/g, self.thousandsSeparator)
            return
        return
    
BindNumbersCards = ->
    document.querySelectorAll '.numbers-card:not(.numbers-card--bound)'
        .forEach (el) ->
            new NumbersCard el
            return
    return

window.addEventListener 'bind-components', BindNumbersCards